(function () {
    "use strict";
    angular
        .module("skillBuilderSaaS")
        .directive("takeExamResult", function () {
        return {
            restrict: "E",
            scope: {},
            bindToController: true,
            templateUrl: "app/account/exam/takeExamResultView.html",
            controller: ["authService", "takeExamResource", "messageService", "$state", "$timeout", TakeExamResultCtrl],
            controllerAs: "vm"
        };
        function TakeExamResultCtrl(authService, takeExamResource, messageService, $state, $timeout) {
            var vm = this;
            vm.dataLoaded = false;
            vm.examInfo = $state.params.examInfo;
            vm.learnerName = authService.authentication.userFirstName + " " + authService.authentication.userLastName;
            takeExamResource.getTakeExamResultViewModel({ examAttemptId: vm.examInfo.examAttemptId }, function (model) {
                vm.model = model;
                $timeout(function () {
                    vm.dataLoaded = true;
                }, 2000);
            }, function (error) {
                messageService.error(error);
            });
        }
    });
}());
